import { useStorage } from '@vueuse/core'
import { useAuthStore } from '@/store/auth'

const SEEN_UIDS_KEY = 'account_security_seen_uids'

export function useAccountSecurityBadge() {
  const seenUids = useStorage<number[]>(SEEN_UIDS_KEY, [])
  const authStore = useAuthStore()

  const showBadge = computed(() => {
    const uid = authStore.user?.uid
    if (!uid) return false
    return !seenUids.value.includes(uid) && authStore.user?.is_all_card_verified !== true
  })

  function markAsSeen() {
    const uid = authStore.user?.uid
    if (uid && !seenUids.value.includes(uid)) {
      seenUids.value.push(uid)
    }
  }

  return {
    showBadge,
    markAsSeen,
  }
}
